// extracted by mini-css-extract-plugin
export default {"innerAccordion":"QuestionsForm-styles-module--innerAccordion--vZgpO"};